module.exports = __webpack_public_path__ + "media/images/front/treatment_support/logo-0c072229257072d9b3b58b4f85b33eaa.svg";